import "core-js/modules/es.string.link.js";
export default defineComponent({
  name: 'ItemInternalLinkInBlockIconLabeledLinks',
  props: {
    title: String,
    image: {
      type: Object,
      default: function _default() {}
    },
    mediaLink: {
      type: Object,
      default: function _default() {}
    },
    externalLinkUrl: String,
    link: String
  },
  setup: function setup(props) {
    var openPageOnTheSameTab = function openPageOnTheSameTab(link) {
      return window.open(link, '_self');
    };
    var openFileInTheSameTab = function openFileInTheSameTab() {
      openPageOnTheSameTab(props.link);
    };
    return {
      openFileInTheSameTab: openFileInTheSameTab
    };
  }
});